import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { ReactComponent as Logo } from "../../shared/Icons/logo.svg";
import tokenUtils from "utils";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SideDrawer from "widgets/SideDrawer/SideDrawer";
import HomeIcon from "@mui/icons-material/Home";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { HEAD_CASHIER, SUB_CASHIER } from "constants/config";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import styles from "./Header.module.scss";

const getMenuItemsForRoles = (roles = []) => {
  const MENU = [
    { key: "home", label: "Home", icon: <HomeIcon />, path: "/" },
    {
      key: "log-cash-flow",
      label: "Log Cash Flow",
      icon: <AccountBalanceWalletIcon />,
      path: "/logCashFlow",
    },
    {
      key: "export-day-sheet",
      label: "Export Day-sheet",
      icon: <FileDownloadOutlinedIcon />,
      path: "/exportDaySheet",
    },
  ];

  const normalized = roles.map((r) => String(r).trim());

  const isHead = normalized.includes(String(HEAD_CASHIER));
  const isSub = normalized.includes(String(SUB_CASHIER));
  if (isHead) return MENU;
  if (isSub) return [MENU[0], MENU[2]];
  return [MENU[0]];
};

const handleOnClickLogoutButton = (navigate) => {
  Cookies.remove("jweToken");
  localStorage.clear();
  navigate("/login");
};

const Header = () => {
  const navigate = useNavigate();
  const loggedIn = tokenUtils.isValidUser();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const toggleDrawer = () => setDrawerOpen((prev) => !prev);
  const roles = (localStorage.getItem("roles") || "")
    .split(",")
    .map((r) => r.trim())
    .filter(Boolean);

  const menu = getMenuItemsForRoles(roles);

  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles.headerRoutes}>
          {loggedIn && (
            <div className={styles.hamburgerContainer}>
              <IconButton onClick={toggleDrawer} size="large">
                <MenuIcon />
              </IconButton>
            </div>
          )}
          <div className={styles.logoAndHomeIconContainer}>
            <Logo />
          </div>
        </div>

        {loggedIn && (
          <div
            className={styles.logOutButton}
            onClick={() => handleOnClickLogoutButton(navigate)}
          >
            Logout
          </div>
        )}
      </div>

      {loggedIn && (
        <SideDrawer
          open={drawerOpen}
          toggleOpen={toggleDrawer}
          menuItems={menu}
          navigate={navigate}
        />
      )}
    </>
  );
};

export default Header;
